import React from 'react'
import StaticPage from '../components/StaticPage'

function PrivacyPage() {
  return (
    <StaticPage title="Privacy Policy" intro="How Wingbeat Paragliding Club handles your data">
      <p className="muted">Last updated: August 2026. This is a starting draft. Please review with the club before relying on it.</p>

      <h2>Who we are</h2>
      <p>
        Wingbeat Paragliding Club is a small, informal paragliding club based in the Scottish Borders.
        For any privacy question, please <a href="/contact">contact us</a>.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>Contact details you give us when you get in touch or ask to join (name, email).</li>
        <li>Content you submit, such as flight logs and photographs.</li>
        <li>Basic, anonymised usage data to help us keep the website working.</li>
      </ul>

      <h2>How we use it</h2>
      <p>
        We use your information only to run the club and this website: to reply to you, to manage
        membership, and to publish content you have chosen to share. We do not sell your data.
      </p>

      <h2>Your rights</h2>
      <p>
        Under UK GDPR you can ask to see, correct, or delete the personal data we hold about you.
        To make a request, <a href="/contact">contact us</a> and we will respond within one month.
      </p>

      <h2>Retention</h2>
      <p>
        We keep personal data only as long as needed for the purpose it was given, or as required by law.
      </p>
    </StaticPage>
  )
}

export default PrivacyPage
